var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignature2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_34199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8844 6.62082C16.2214 6.03367 16.0135 5.28434 15.4222 4.95473C14.8438 4.63231 14.1137 4.83242 13.7806 5.40469L13.0309 6.71656L13.7806 7.71199L15.1348 7.93274L15.8844 6.62082Z",
    fill: "#F6FAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46844 19.271V21.4266C7.46844 22.2106 8.10403 22.8462 8.88805 22.8462C9.67208 22.8462 10.3077 22.2106 10.3077 21.4266V19.1367L7.46844 19.271Z",
    fill: "#FFBBA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3079 20.4261V21.4275C10.3079 22.2116 10.9434 22.8471 11.7275 22.8471C12.5115 22.8471 13.1471 22.2116 13.1471 21.4275V19.6309L10.3079 20.4261Z",
    fill: "#FFCBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58831 17.6953H9.54815L9.54413 17.7023L9.58831 17.6953Z",
    fill: "#FFDDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27549 10.9451C7.27733 11.7186 6.45057 12.6909 5.8474 13.8004L4.15709 16.9098C3.82326 17.5239 4.03834 18.2921 4.64248 18.6436C5.204 18.9703 5.91158 18.8265 6.30483 18.3289L9.92955 14.058L11.1726 9.92383C10.144 9.93766 9.09979 10.3062 8.27549 10.9451Z",
    fill: "#FFDDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.876 13.4231C18.6111 13.4231 18.3507 13.3535 18.1211 13.2213L13.6344 10.6378L13.5977 10.627L6.69893 17.9424L6.6037 19.0603C6.6037 19.8141 7.21475 20.4251 7.9685 20.4251H11.7956C12.5755 20.4251 13.3416 20.619 14.0334 20.9791C14.6873 21.3196 15.6266 21.6911 16.6123 21.6911C19.3017 21.6911 21.5059 20.1741 21.5059 20.1741L21.9521 13.4231L18.876 13.4231Z",
    fill: "#FFDDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5286 17.6951H8.63379C8.3102 17.6951 8.04785 17.4328 8.04785 17.1092C8.04785 16.7856 8.3102 16.5232 8.63379 16.5232H12.5286C13.2927 16.5232 14.0411 16.2593 14.6361 15.7801L15.1479 15.3679C15.4 15.1649 15.7688 15.2047 15.9718 15.4567C16.1747 15.7087 16.135 16.0776 15.883 16.2806L15.3712 16.6928C14.5686 17.3391 13.5592 17.6951 12.5286 17.6951Z",
    fill: "#FFCBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96853 17.6954H9.54814L14.4863 9.0743L13.7154 7.83789L12.3549 7.88707L5.0715 20.4578C5.04193 20.5088 5.02018 20.564 5.00689 20.6214L4.57928 22.4716C4.4574 22.9989 5.0476 23.4004 5.4933 23.0935L7.06896 22.0084C7.14393 21.9568 7.20596 21.8886 7.25033 21.8091L8.02342 20.4249H7.9685C7.21475 20.4249 6.60369 19.8139 6.60369 19.0601C6.60369 18.6891 6.75189 18.3529 6.99209 18.107C7.23998 17.8532 7.58576 17.6954 7.96853 17.6954Z",
    fill: "#6D889B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.031 6.7168L12.3549 7.88793L14.4863 9.07516L15.1348 7.93297L13.031 6.7168Z",
    fill: "#5B7184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4691 21.4812H21.852C21.5588 21.4812 21.3211 21.2435 21.3211 20.9503V12.7106C21.3211 12.4174 21.5588 12.1797 21.852 12.1797H23.4691C23.7623 12.1797 24 12.4174 24 12.7106V20.9503C24 21.2435 23.7623 21.4812 23.4691 21.4812Z",
    fill: "#FF935A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_34199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature2);
export default __webpack_public_path__ + "static/media/Signature2.0f65fbd22d867fbb056f4c387e9b43cc.svg";
export { ForwardRef as ReactComponent };